import React, { useEffect, useState, useRef, useCallback} from 'react' 
import { Link, Route, Routes } from 'react-router-dom'
import  '../layout/ProdDetail.Module.css'
import  '../layout/Loading.Module.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useParams, useLocation } from 'react-router-dom';
import Slider from "react-slick";
import { prods } from '../prods'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';
import {tabela, material, acabamento, ip } from '../legenda'
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import InnerImageZoom from 'react-inner-image-zoom';
import { useTranslation } from 'react-i18next';
import Dropdown from "./Dropdown";
import RecentProds from './RecentProds'
import { useAuth } from './AuthContext';
import angulo from '../images/icons/angle.png'
import power from '../images/icons/power-button.svg'
import ac from '../images/icons/ac.jpg'
import ampere from '../images/icons/ampere.png'
import qtcx from '../images/icons/delivery-box.png'
import ugr from '../images/icons/ugr.png'
import poten from '../images/icons/poten1.png'
import correnNomi from '../images/icons/correNomi.png'
import potenNom from '../images/icons/potenNo.png'
import ik from '../images/icons/ik.png'
import letra from '../images/icons/letra.png'
import rolo from '../images/icons/rolo.png'
import tempe from '../images/icons/tempe.png'
import cor from '../images/icons/cor.png'
import led from '../images/icons/led.png'
import ce from '../images/marcacoes/ce.png'
import rohs from '../images/marcacoes/rohs.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { faCogs  } from '@fortawesome/free-solid-svg-icons'
import ProductCard from './ProductCard'
import { getTranslatedColorName } from '../colors';
import { getTranslatedMatName } from '../material';
import { colorTemperatureStyles } from './colorTemperatureStyles';
import { LazyLoadImage } from "react-lazy-load-image-component";
import Cookies from 'js-cookie';  // Importe a biblioteca js-cookie
import { useLanguage } from './LanguageContext';
import useScrollReveal from './hooks/useScrollReveal';
import { ourBrands,reBrands } from '../brands'
import useGoogleTranslateRefresh from './hooks/useGoogleTranslateRefresh';

export const addToRecentView = (productId) => {
  let recentViews = Cookies.get('recentViews');
  recentViews = recentViews ? JSON.parse(recentViews) : [];
  productId = String(productId);
  recentViews = recentViews.filter(id => id !== productId);
  recentViews.unshift(productId);
  if (recentViews.length > 8) {
    recentViews = recentViews.slice(0, 8);
  }
  Cookies.set('recentViews', JSON.stringify(recentViews), { expires: 7 }); // Armazena por 7 dias
};

  const customTranslations = {
  'campânula': {
    'es': 'Campana',
    'en': 'High bay',
    'fr': 'Campanule',
    'it': 'Campanula',
    'zh-CN': '风铃草'
  },
  'luminária': {
    'es': 'Luminaria',
    'en': 'Luminaire',
    'fr': 'Luminaire',
    'it': 'Apparecchio di illuminazione',
    'zh-CN': '灯具'
  }
};

const ProdDetail =({props})=> {
  useScrollReveal(true);
  const location = useLocation(); // Para detectar a mudança de rota
  const { user, logout, toggleFavorite} = useAuth();
  const { selectedLanguage } = useLanguage(); 
  const { t, i18n } = useTranslation('');
    // Função para aplicar a tradução personalizada
  const applyCustomTranslation = (nomeProduto, lang) => {
    let newName = nomeProduto;
    if (lang && lang !== 'pt') {
      for (const originalWord in customTranslations) {
        const translatedWord = customTranslations[originalWord][lang];
        if (translatedWord) {
          const regex = new RegExp(originalWord, 'gi');
          newName = newName.replace(regex, translatedWord);
        }
      }
    }
    return newName;
  };

  const [translatedProductName, setTranslatedProductName] = useState('');
  const [translatedProductDescri, setTranslatedProductDescri] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [translatedItensDescri, setTranslatedItensDescri] = useState({}); // Para armazenar descrições traduzidas
  const currentLanguage = i18n.language;

  const navigate = useNavigate();
  const GotToNewPage =(nome,id)=>{
    if (typeof nome !== 'string' || !nome.trim()) {
      console.error("Erro: 'nome' está indefinido ou não é uma string válida:", nome);
      return;
    }
    const url = `/prodetail/${encodeURIComponent(nome.replace(/\s+/g, '-').toLowerCase())}/${id}`;
    window.open(url, '_blank');
  }

  const twoFunctions =(nome,id)=>{
    addToRecentView(id)
    GotToNewPage(nome,id)
  }
  const [mainImage, setMainImage] = useState('');
  //const [galeria, setGaleria] = useState([]); imagens da tabela imagens_produto 
  const [translatedCategoryName, setTranslatedCategoryName] = useState('');
  let {id} = useParams();
  /************Lista de produtos************/
 // Limita o número de produtos exibidos
    const [product, setProduct] = useState(null);
    const [translatedName, setTranslatedName] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [especifi, setEspecifi] = useState([]);
    const [acessorios, setAcessorios] = useState([]);
useEffect(() => {
  axios.get(`https://backend-theta-gold-17.vercel.app/api/productFull/${id}`, { timeout: 25000 })
    .then(response => {
      if (response.data) {
        setProduct(response.data);
        setMainImage(response.data.imgP);
        setEspecifi(response.data.especifi); // <- Aqui mantém o state separado
         // ✅ Aqui acessa os acessórios diretamente
        setAcessorios(response.data.acessorios || []);
        setTranslatedName(applyCustomTranslation(response.data.nome, selectedLanguage));
        sessionStorage.setItem(`product-${id}`, JSON.stringify(response.data));
      } else {
        setError("Produto não encontrado");
      }
      setLoading(false);
    })
    .catch(error => {
      const errorMessage = error.response?.data?.error || t('pdetail.error');
      setError(errorMessage);
    });
}, [id, selectedLanguage]);
/*Traduzir categoria de produtos de acordo com as listas Json*/
const translateCategory = (categoryName, language) => {
  const allBrands = [...ourBrands, ...reBrands];

  for (const brand of allBrands) {
    const categoryItem = brand.category.find(cat => cat.name === categoryName);
    if (categoryItem) {
      return categoryItem.nome[language] || categoryName;
    }
  }
  // Retorna o nome original se nenhuma tradução for encontrada
  return categoryName;
};

useEffect(() => {
  if (product?.nomeC) {
    const translatedName = translateCategory(product.nomeC, selectedLanguage);
    setTranslatedCategoryName(translatedName);
  }
}, [product, selectedLanguage]);

const [recomendMarcCate, setRecomendMarcCate] = useState([]);
useEffect(() => {
  if (!product?.id_Cat) return; // ✅ só roda quando o produto tiver a categoria

  fetch(`https://advancelighting.pt/recomendedMarcAndCat.php?categoria=${product.id_Cat}`)
    .then(res => res.json())
    .then(prod => {
      setRecomendMarcCate(Array.isArray(prod) ? prod : []);
    })
    .catch(err => console.error("Erro ao buscar recomendados:", err));
}, [product?.id_Cat]);
    
    // Traduzir as descrições dos itens
    const reapplyGoogleTranslate = () => {
      const savedLanguage = sessionStorage.getItem('language');
      const dropdown = document.querySelector('.goog-te-combo');
    
      if (savedLanguage && savedLanguage !== 'pt' && dropdown) {
        dropdown.value = savedLanguage;
        dropdown.dispatchEvent(new Event('change'));
      }
    };
    useEffect(() => {
      if (product) {
        // Espera um pouco até o conteúdo renderizar
        setTimeout(() => {
          reapplyGoogleTranslate();
        }, 500);
      }
    }, [product]);

  const maxProductsToShow = 15; // Limite de produtos para exibir
  const itensFiltrados = especifi;
  const [selectedFilters, setSelectedFilters] = useState({});
  const categoryProperties = {
    1: ["k"], 2: ["k","medida"], 3: ["k"],4: ["k"], 5: ["k"], 6: ["k"],7: ["k"],8: ["k"],9: ["k"],10: ["k"],11: ["k"],12: ["k"], 13: ["k"],14: ["k"],15: ["k"],16: ["k"], 17: ["k"],18: ["k"],
    19: ["k"],20: ["k"],21: ["k"],22: ["k"], 23: ["k"],24: ["k"],25: ["k"],26: ["k"],31: ["k"], 38: ["k"], 43: ["k"],44: ["k"],45: ["k"],46: ["k"],47: ["k"],49: ["k"], 50: ["k"],51: ["k"],55: ["k"],56: ["k"],57: ["k"],58: ["k"]
  };
  // Armazena os filtros de forma simples
  const handleSelection = (key, value) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value, // Apenas atribui o valor diretamente
    }));

    if (key === 'cor') { // Verifica se a propriedade é "cor"
      const colorImage = especifi.find(item => item.cor === value)?.img;
      if (colorImage) {
        setMainImage(colorImage); // Atualiza a imagem principal
      }
    }
  };

  // Remove duplicados nos valores de cada propriedade
  const uniqueValues = (property) => [
    ...new Set(itensFiltrados.map((item) => item[property]).filter(Boolean)),
  ];

  // Filtra os itens com base nos filtros selecionados
  const filteredItems = itensFiltrados.filter((item) =>
    Object.entries(selectedFilters).every(([key, value]) => item[key] === value)
  );

  useEffect(() => {
    if (filteredItems.length > 0) {
      setSelectedItem(filteredItems[0]); // Define o primeiro item que atende aos filtros
    } else {
      setSelectedItem(null); // Limpa o item selecionado se nenhum atender
    }
  }, [filteredItems]);
const createSliderConfig = (options = {}) => ({
  autoplay: true,
  dots: false,
  arrows: false,
  infinite: false,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots:false,
      }
    }
  ],
  ...options, // Sobrescreve as configurações padrão com as opções específicas
});

const recomen2 = createSliderConfig({
  dots: false,
  arrows: true,
});

    useEffect(() => {
      const slickTrack = document.querySelector('.slick-track');
      if (itensFiltrados.length < 4 && slickTrack) {
        slickTrack.style.transform = 'translate3d(0px, 0px, 0px)'; // Mover o track para o início
        slickTrack.classList.add('float-left-important'); // Adiciona a classe
      } else if (slickTrack) {
        slickTrack.classList.remove('float-left-important'); // Remove a classe se não for mais necessário
      }
    }, [itensFiltrados.length]);
  {/*Image zoom on hover*/}
    {/*Replace for images of references */}
    if (loading) {
      return  <>
      <style>{'body '}</style>
         <div className="containe" >
           <div className="box loading">
         <div className="content">
           <div className="content"> 
        <div className="loading-dots">
        <h1 className='mb-3'>{t('pdetail.carregando')}</h1>
          <div className="loading-dots--dot"></div>
          <div className="loading-dots--dot"></div>
          <div className="loading-dots--dot"></div>
        </div>
        </div>
      </div>
    </div>
    </div>
      </>
    }
    
    if (error) {
      return <p>Error: {error}</p>;
    }
    if (!product) {
      return <p>Product not found</p>;
    }
    
    const propertiesToDisplay = categoryProperties[product.id_Cat] || [];
    const colorStyles = {
      PR: { backgroundColor: 'black', border:' 2px solid white', },  // Preto
      BR: { backgroundColor: 'white', border:' 2px solid white' },  // Branco
      CZ: { backgroundColor: 'grey', border:' 2px solid grey' },   // Cinza
      VR: { backgroundColor: 'red', border:' 2px solid red'},    
      NQ: { backgroundColor: '#727472', border:' 2px solid rgba(132, 129, 129, 0.94)'},    
      TRP: { backgroundColor: 'transparent', color: 'black' }, // Transparente
      'BR+PR': { backgroundColor: 'linear-gradient(to right, white, black)', color: 'black' }, // Branco e Preto
      'PR+VR': { backgroundColor: 'linear-gradient(to right, black, red)', color: 'white' },  // Preto e Vermelho
      // Adicione mais combinações conforme necessário
    };

const corteMedMap = { 'mm': 'mm', 'cm': 'cm','livre': 'Livre/Free','mt': 'mt'};
const todasImagens = [product.imgP, ...product.imagens.filter(img => img !== product.imgP)];
const settingsImagens = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
};

const groupedColorMap = {
  yellow: ["2500K","2700K","3000K"],
  green: ["4000K", "4200K", "Verde"],
  blue: ["5000K","5500K","5700K","6000K","6500K","Azul"],
  pink: ["Rosa", "Rosa/Pink"],
  red: ["Vermelho"],
  orange: ["Laranja","2000K","2200K"],
  gold: ["Amarelo"],
  purple: ["Roxo"],
};

// Gera automaticamente o objeto invertido: { "3000K": "yellow", ... }
const colorClasses = Object.entries(groupedColorMap).reduce((acc, [color, values]) => {
  values.forEach(value => {
    acc[value] = color;
  });
  return acc;
}, {});

const getColorClass = (value) => {
  return colorClasses[value] || "";
};

let fichaTecnicaUrl = product?.ficha_tecnica;

if (selectedItem?.fichaIndex === 2) fichaTecnicaUrl = product?.ficha_tecnica_2;
if (selectedItem?.fichaIndex === 3) fichaTecnicaUrl = product?.ficha_tecnica_3;
  return (
  <div className='Prodetail'>
    <>  
  {/* Hello world */}
  <div className="container">
      <nav aria-label="breadcrumb" className="breadcrumbs medium-font">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link to="/"role="button" tabIndex="0" className='text-capitalize'>Home</Link></li>
        <li className="breadcrumb-item"><Link to="/produtos" className='text-capitalize'>{t('homepage.produtos')}</Link></li>
        <li className="breadcrumb-item active" aria-current="page"><Link to={'/search-results/' + product?.nomeC} className='text-capitalize'>{translatedCategoryName}</Link></li>
      </ol>
      </nav>
        <div className="row prod-box">
          <div className="col-lg-5">
            <div className="row">
              <div className=" col-lg-12 main-image">
               {product.novo === 1  ? <h6 className='novidades-button '>{t('pdetail.novo')}</h6> : ""}
                {mainImage ? (<InnerImageZoom src={mainImage} zoomScale={1.5} zoomType="hover" hasSpacer={false} fullscreenOnMobile={false}// Remove o espaçamento interno
                  alt={product?.nome} className="img-thumbnail p-0 border-0"/>   ) : (
                  <p>{t('pdetail.carregando')}...</p>
                )}
              </div>
              
              {/*Inserir aqui as imagens por referência*/}
              <div className='grid-carousel mb-5'>
                {todasImagens.length > 4 ? (
                  <Slider {...settingsImagens}>
                    {todasImagens.map((imgUrl, index) => (
                      <div className="img-item" key={index}>
                        <img src={imgUrl} alt={`Imagem ${index}`} className="img-thumbnail p-0 border-0" onClick={() => setMainImage(imgUrl)} />
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <div className="d-flex flex-wrap">
                    {todasImagens.map((imgUrl, index) => (
                      <div className="img-item me-2" key={index}>
                        <img src={imgUrl}  alt={`Imagem ${index}`} className="img-thumbnail p-0 border-0"  onClick={() => setMainImage(imgUrl)} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
    <div className="col-lg-7 info-prod">
      <div className="card product-info">
        <div className="card-body">
          <h1 className='product-title mb-4 translate scroll-top'>{translatedName}</h1>
          <div className='logo-price mb-4'>
          <li className="list-group-item logo-prod mb-3 scroll-bottom">
            <div className={`scroll-bottom brand-img brand-${product?.id_Mar}`}>
            <img src={product?.logo} alt="Product Logo" />
            </div>
            </li>

          <div className='price-field'>
            {selectedItem && (
              <>
                {/* Caso seja 'Sob-consulta' */}
                {selectedItem.pvp_status === 'Sob-consulta' ? (
                  !user ? (
                    <p className='message-pvp'>{t('pdetail.sobcon')}</p>
                  ) : (
                    selectedItem.precoL != null && !isNaN(selectedItem.precoL) ? (
                      <>
                      <p className='price-spotlight'>{selectedItem.precoL.toFixed(2)}€</p>
                      <span className='message-pvp price-bold translate'>Preço Líquido*</span>
                      </>
                    ) : (
                      <p className='message-pvp'>{t('pdetail.sobcon')}</p>
                    )
                  )
                ) : selectedItem.pvp_status === '*' ? (
                  <>
                    <p className='message-pvp'>{t('pdetail.stockepvp')}</p>
                    <span className='message-pvp stock-pvp'>{t('pdetail.stockepvp2')}</span>
                  </>
                ) : (
                  /* Caso o status seja válido, mas diferente dos anteriores */
                  <>
                    {user && selectedItem.precoL != null && !isNaN(selectedItem.precoL) ? (
                      <>
                        <p className='price-spotlight liquid-price'>
                          {selectedItem.precoL.toFixed(2)}
                          <span className='message-pvp price-bold translate'>Preço Líquido*</span>
                          {selectedItem.por_metro === 1 ? '€/m' : '€'}
                        </p>
                        {selectedItem.qtd_minima > 1 && (
                          <p className='message-pvp qtd-min translate'>
                            Quantidade mínima: {selectedItem.qtd_minima}
                          </p>
                        )}
                        {/* NÃO exibe o span de P.V.P.* porque é precoL */}
                      </>
                    ) : selectedItem.pvp != null && !isNaN(selectedItem.pvp) ? (
                      <>
                        <p className='price-spotlight'>
                          {selectedItem.pvp.toFixed(2)}
                          {selectedItem.por_metro === 1 ? '€/m' : '€'}
                        </p>
                        <span className='message-pvp price-bold'>P.V.P.*</span>
                      </>
                    ) : (
                      <p className='message-pvp'>{t('pdetail.sobcon')}</p>
                    )}
                  </>
                )}
              </>
            )}
          </div>

          </div>
          <ul className="list-group list-group-flush">
            {selectedItem && (
            <div className='prod-reference'>
              <span>{t('pdetail.ref')}: </span>
              <span className='prod-reference-value'> {selectedItem.ref}</span>
            </div>
            )}
            <li className="list-group-item">
              <div className='prod-info-title'>
              {t('pdetail.caraGerais')}:
              </div>
            </li>
            <li className="list-group-item info-geral basic-info">
            <p className='text-capitalize'> {t('pdetail.tipo')}: <b className=''>{translatedCategoryName}</b></p>
            {(product?.ip != null) && (<><p><img src="https://www.efectoled.com/img/core/feature_icons/feature_15.svg" alt="IP20" width={24} height={24} />IP:<b> {product.ip}</b></p> </> )}
            {(product?.cri != null) && (<><p><img src="https://www.efectoled.com/img/core/feature_icons/feature_26.svg" alt="cri" width={24}  height={24}/> CRI:<b> {product.cri}</b></p></>)}
            {(product?.volt != null) && (<><p><img src="https://www.efectoled.com/img/core/feature_icons/feature_7.svg" alt="volt" width={24} height={24} />{t('pdetail.poten')}:<b> {product.volt}V</b></p> </>)}
            {(product?.ik != null) && (<><p><img src={ik} alt="ik" width={24} height={24} />IK:<b> {product.ik}</b></p></>)}
            {(product?.ac != null) && ( <p>AC:<b> {product.ac}V</b></p>)}
            {(product?.dc != null) &&  ( <p>DC:<b> {product.dc}V</b></p>)}
            {(product?.pcb != null) && (<p>PCB:<b> {product.pcb}OZ</b></p> )} 
            {(product?.dim != null) && (<p>Dimensões:<b> {product.dim} </b></p> )} 
            {(product?.ugr != null) && (<><p><img src={ugr} alt="ugr" width={24} height={24} />UGR:<b> {product.ugr}</b></p> </>)} 
            {(product?.ampere != null) && (<p><img src={ampere} alt="ampere" width={24} height={24} />:<b> {product.ampere}A</b></p>)} 
            </li>
            {(product?.tempe != null) && 
            (
              <li className="list-group-item info-geral temp">
              <p><img src={tempe} alt="ampere" width={24} height={24} />:<b> {product.tempe} </b></p> 
              </li>
            )}

            <li className="list-group-item info-geral mb-2">
              <span>
              {propertiesToDisplay.map((property) => {
            const values = uniqueValues(property);
            
            // Se não houver valores para essa propriedade, não renderiza nada
            if (values.length === 0) {  return null;  }
            return (
              <React.Fragment key={property}>
                <div className="prod-info-title">
                  {t(`pdetail.${property}`)}:
                </div>
                {values.map((value, index) => {
                  const isCorProperty = property === 'cor';
                  const isSelected = selectedFilters[property] === value;
                  const style = colorTemperatureStyles[value];
                  const buttonStyle = {
                    margin: '5px', padding: '7px',
                    backgroundColor: isSelected ? 'rgb(128 128 128 / 66%)' : '#efefeff0',
                    color: isSelected ? '#efefeff0' : '#808080cf',
                    border: isSelected ? '2px solid rgba(239, 239, 239, 0.94)' : '2px solid #808080cf',
                    borderRadius: isCorProperty ? '50%' : '5px', cursor: 'pointer',
                    position: 'relative', 
                    overflow: 'hidden', 
                    textShadow: isSelected ? '0.7px 0.7px #272626' : ''
                  };

                  if (isCorProperty) {
                    const colorStyle = colorStyles[value]; // Busca o estilo pelo valor da cor
                    if (colorStyle) {
                      buttonStyle.border = isSelected ? colorStyle.border : colorStyle.border;
                      buttonStyle.backgroundColor =  isSelected ? colorStyle.backgroundColor : 'transparent';
                      buttonStyle.boxShadow =  isSelected ? '0 0 5px grey, inset 0 0 12px grey' : '0 0 2px grey, inset 0 0 3px grey';
                    }
                  }
                  return (
                    <>  
                    {value === "RGB" ? (
                      <button key={`${property}-${index}`} className={`btn10 ${property === "k" ? getColorClass(value) : ""}`} onClick={() => handleSelection(property, value)} style={buttonStyle}>
                        <span className="r">R</span>
                        <span className="g">G</span>
                        <span className="b">B</span>
                      </button>
                    ) : (
                     <button key={`${property}-${index}`} className={`btn10 ${property === "k" ? getColorClass(value) : ""}`} onClick={() => handleSelection(property, value)} style={buttonStyle}>
                      <span className="span-style translate"> {value} {value === 'Vermelho' && ''} {property === "w" ? 'W' : ''} </span>
                    </button>
                    )}
                    
                    </>
                  );
                })}
              </React.Fragment>
            );
          })}
              </span>
            </li>

          {selectedItem && (
                  <>
               <ul className="especifi-block mt-10 p-3 3xl:grid-cols-4 gap-y-4 gap-x-6 border rounded mb-3">
                {selectedItem.w != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={poten}  alt="Potencia" width={24} height={24} />
                <div>
                  <p>{t('pdetail.potencia')}</p> <p className="font-medium">{selectedItem.w}W</p>
                </div>
                </li>
                }
               {selectedItem.cor != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={cor}  alt="Cor" width={24} height={24} />
                <div>
                  <p>{t('pdetail.cor')}</p> <p className="font-medium">{getTranslatedColorName(selectedItem.cor, i18n.language)}</p>
                </div>
                </li>
                }
                {selectedItem.medida != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src="https://www.efectoled.com/img/core/feature_icons/feature_189.svg"  alt="Medida" width={24} height={24} />
                <div>
                <p>{t('pdetail.medida')}</p> <p className="font-medium">
                   {selectedItem.medida} {
                    product?.id_Cat === 61 ? "(mm²)"  : product?.id_Mar === 4 ? "(cm)" : "(mm)"
                  }
                </p>
                </div>
                </li>
                }

                {selectedItem.rolo != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={rolo}  alt="Medida" width={24} height={24} />
                <div>
                <p>{t('pdetail.rolo')}</p> <p className="font-medium translate"> {selectedItem.rolo} </p>
                </div>
                </li>
                }

                {selectedItem.letras != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={letra}  alt="letra" width={24} height={24} />
                <div>
                <p>Letras</p> <p className="font-medium">{selectedItem.letras}</p>
                </div>
                </li>
                }

                {selectedItem.cor_carga != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src="https://www.efectoled.com/img/core/feature_icons/feature_2855.svg"  alt="Furo" width={24} height={24} />
                <div>
                <p>{t('pdetail.ccarga')}</p> <p className="font-medium">{selectedItem.cor_carga}</p>
                </div>
                </li>
                }

               {selectedItem.furo != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src="https://www.efectoled.com/img/core/feature_icons/feature_2855.svg"  alt="Furo" width={24} height={24} />
                <div>
                <p>{t('pdetail.furo')}</p> <p className="font-medium">{selectedItem.furo} (mm)</p>
                </div>
                </li>
                }
                {selectedItem.angulo != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={angulo}  alt="Angulo" width={24} height={24} />
                <div>
                  {product.id_Cat != 33 ?  <p>{t('pdetail.angulo')}</p>  :<p>{t('pdetail.angulodet')}</p> } <p className="font-medium translate">{selectedItem.angulo}º</p>
                </div>
                </li>
                }
                {selectedItem.mat != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src="https://www.efectoled.com/img/core/feature_icons/feature_18.svg"  alt="Material" width={24} height={24} />
                <div>
                  <p>{t('pdetail.mat')}</p> <p className="font-medium">{getTranslatedMatName(selectedItem.mat, i18n.language)}</p>
                </div>
                </li>
                }
                {selectedItem.lm != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src="https://www.efectoled.com/img/core/feature_icons/feature_163.svg"  alt="lm" width={24} height={24} />
                <div>
                  <p>{t('pdetail.lm')}</p> <p className="font-medium">{selectedItem.lm}{selectedItem.l_W !== 1 ? "lm" : "lm/W "}</p>
                </div>
                </li>
                }
               {selectedItem.corte != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src="https://www.efectoled.com/img/core/feature_icons/feature_2855.svg"  alt="Corte" width={24} height={24} />
                <div>
                <p>{t('pdetail.corte')}</p> <p className="font-medium">{selectedItem.corte}{corteMedMap[selectedItem.corteMed] || ''}</p>
                </div>
                </li>
                }

               {selectedItem.led != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={led}  alt="Corte" width={24} height={24} />
                <div>
                <p>Led</p> <p className="font-medium">{selectedItem.led}</p>
                </div>
                </li>
                }
                
               {selectedItem.motor != null && 
                <li className="flex items-center gap-2 text-sm">
                <FontAwesomeIcon icon={faCogs} width={24} height={24}/>
                <div>
                <p className='translate'>Motor DC</p><p className="font-medium">{selectedItem.motor}</p>
                </div>
                </li>
                }
 
              {selectedItem.poten_max != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={power} alt="lm" width={24} height={24} />
                <div>
                  <p>{t('pdetail.potmax')}</p> <p className="font-medium">{selectedItem.poten_max}kW</p>
                </div>
                </li>
              }

                {selectedItem.corrente_ac != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={ac}  alt="lm" width={24} height={24} />
                <div>
                  <p>{t('pdetail.correAC')}</p> <p className="font-medium">{selectedItem.corrente_ac}kW</p>
                </div>
                </li>
                }

                {selectedItem.poten_nom != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={potenNom}  alt="lm" width={24} height={24} />
                <div>
                  <p>{t('pdetail.potnom')}</p> <p className="font-medium">{t('pdetail.ate')} {selectedItem.poten_nom}kW</p>
                </div>
                </li>
                } 
                
               {selectedItem.corrente_no != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={correnNomi}  alt="lm" width={24} height={24} />
                <div>
                  <p>{t('pdetail.correnom')}</p> <p className="font-medium">{t('pdetail.ate')} {selectedItem.corrente_no}A Max.</p>
                </div>
                </li>
                }
    
                {selectedItem.qtcx != null && 
                <li className="flex items-center gap-2 text-sm">
                <img src={qtcx}  alt="Angulo" width={24} height={24} />
                <div>
                  <p>{t('pdetail.qtdcx')} </p> <p className="font-medium">{selectedItem.qtcx}</p>
                </div>
                </li>
                }
                </ul>
                </>)}

              {(product?.descri != null) && 
              (
                <div className='prod-info mt-3'>
                <div className='prod-descri-title mb-2'>{t('pdetail.descri')}</div>
                  <p className='translate' dangerouslySetInnerHTML={{ __html: product?.descri }}></p>
                </div>
              )} 
              </ul>
                <>
                <>        
              {user ? 
                (product?.ficha_tecnica || product?.cert_confor || product?.ies) && (
                  <>
                    <h5 className='mt-4 prod-descri-title'>Downloads</h5>
                    <hr className="card-line w-100 line-downloads" />
                    <li className="list-group-item mt-2 download-buttons">
                    {fichaTecnicaUrl && (
                      <a href={fichaTecnicaUrl} target="_blank" rel="noopener noreferrer" className="ft-tag" >
                        <button>
                          <FontAwesomeIcon icon={faFilePdf} size="1x" />
                          {t('pdetail.ft')}
                        </button>
                      </a>
                    )}
                      {product?.cert_confor && 
                        (
                          <a href={product.cert_confor} target="_blank" rel="noopener noreferrer" className='mt-1 ft-tag'>
                            <button className=''><FontAwesomeIcon icon={faFilePdf} size="1x" />{t('pdetail.certConfor')}</button>
                          </a>
                        )
                      }
                      {product?.ies && 
                        (
                          <a href={product.ies} target="_blank" rel="noopener noreferrer" className='mt-1 ft-tag'>
                            <button className=''> <FontAwesomeIcon icon={faFilePdf} size="1x" />{t('pdetail.ies')} </button>
                          </a>
                        )
                      }
                    </li>
                    <hr className="card-line w-100 line-downloads mt-2" />
                  </>
                    ) : ""}
                </> 
                </>
      {/* {user ? : ""} */}
      {/* {(selectedItem && selectedItem.pvp != null && !isNaN(selectedItem.pvp)) || (user && selectedItem.precoL != null && !isNaN(selectedItem.precoL)) ? (
        <p className='mt-2 info-pvp mb-2'>*{t('pdetail.pvp')}</p> ) : null}*/}
        {selectedItem && (selectedItem.pvp != null && !isNaN(selectedItem.pvp)) || 
        (user && selectedItem && selectedItem.precoL != null && !isNaN(selectedItem.precoL)) ? (
          <p className='mt-2 info-pvp mb-2'>*{t('pdetail.pvp')}</p>
        ) : null}
        <div className='mt-3 marcacoes'>
          <LazyLoadImage src={ce} alt="ce" />
          <LazyLoadImage src={rohs} alt="rohs" />
        </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container technical-details mb-5">
    <div className="prod-info-title mb-1">{t('pdetail.espeTecni')}</div>
    
<Table striped bordered hover>
    {/* Renderizar a tabela apenas se houver itens filtrados */}
    {itensFiltrados.length > 0 && (
      <>
        <thead>
          <tr>
            <th>Ref</th>
            {/* Exibir o cabeçalho condicionalmente com base no primeiro item filtrado */}
            {itensFiltrados[0]?.w != null && <th>W</th>}
            {itensFiltrados[0]?.led != null && <th>Led</th>}
            {itensFiltrados[0]?.furo != null && <th>{t('pdetail.furo')} (mm)</th>}
            {itensFiltrados[0]?.descri != null && <th>{t('pdetail.descritb')}</th>}
            {itensFiltrados[0]?.cor != null && <th> {t('pdetail.cor')}</th>}
            {itensFiltrados[0]?.mat != null && <th>{t('pdetail.mat')} </th>}
            {itensFiltrados[0]?.k != null && <th>K</th>}
            {itensFiltrados[0]?.lm != null && <th>LM</th>}
            {itensFiltrados[0]?.corte != null && <th>{t('pdetail.corte')}</th>}
            {itensFiltrados[0]?.poten_nom != null && <th>{t('pdetail.potnom')}</th>}
            {itensFiltrados[0]?.medida != null && <th> {t('pdetail.medida')} {product?.id_Cat === 61 ? "(mm²)" : product?.id_Mar === 4 ? "(cm)" : "(mm)"}</th>}
            {itensFiltrados[0]?.angulo != null && <th>{t('pdetail.angulo')}</th>}
            {itensFiltrados[0]?.qtcx != null && <th>QT/CX</th>}
            {<th>P.V.P</th>}
          </tr>
        </thead>
        <tbody>
          {/* Renderizar as linhas da tabela com base nos itens filtrados */}
          {itensFiltrados.map((item, index) => (
            <tr key={index}>
              <td data-label={t("pdetail.ref")}><b>{item.ref}</b></td>
              {item?.w != null && <td data-label="watt">{item.w}W</td>}
              {item?.led != null && <td data-label="led">{item.led}</td>}
              {item?.furo != null && <td data-label={t("pdetail.furo")}>{item.furo}</td>}
              {item?.descri != null && <td data-label={t("pdetail.descri")}>{translatedItensDescri[item.ref] || item.descri}</td>}
              {item?.cor != null && <td data-label={t("pdetail.cor")}>{getTranslatedColorName(item.cor, i18n.language)}</td>}
              {item?.mat != null && <td data-label="mat">{getTranslatedMatName(item.mat, i18n.language)}</td>}
              {item?.k != null && <td data-label="k" className="text-uppercase translate">{item.k}</td>}
              {item?.lm != null && <td data-label="lm">{item.lm}{item.l_W != 1 ? "lm" : "lm/W "}</td>}
              {item?.corte != null && <td data-label={t("pdetail.corte")}>{item.corte}{corteMedMap[item.corteMed] || ''}</td>}
              {item?.poten_nom != null && <td data-label={t("pdetail.ate")}>{item.poten_nom} kW</td>}
              {item?.medida != null && <td data-label={t("pdetail.medida")}>{item.medida}</td>}
              {item?.angulo != null && <td data-label={t("pdetail.angulo")}>{item.angulo}°</td>}
              {item?.qtcx != null && <td data-label="qtcx">{item.qtcx}</td>}
              {item.pvp_status === 'Sob-consulta' ? (
              <td data-label="pvp">{t('pdetail.sobcon')}</td> ) : item.pvp_status === '*' ? ( <td data-label="pvp">*</td>
             ) : item.pvp ? (
              <td data-label="pvp">{`${parseFloat(item.pvp).toFixed(2)}${item.por_metro ? "€/m" : "€"}`}</td>
             ) : null}
            </tr>
            ))}
        </tbody>
      </>
    )}
</Table>

 {itensFiltrados.some(item => String(item.qtcx) == '*' ) && (
    <div style={{ color: 'var(--logo-bege)', fontWeight: 'bold', marginBottom: '10px' }}>
      {(product?.nomeC == "Lâmpadas") && (t('pdetail.qtcx'))}
      {(product?.nomeC == "Ligadores") && ('*'+t('pdetail.msg2'))}
      {(product?.nomeC == "Suportes") && ('*'+t('pdetail.msg3'))}
    </div>
  )}

{itensFiltrados.some(item => String(item.qtcx).includes('4**')) && (
    <div style={{ color: 'var(--logo-bege)', fontWeight: 'bold', marginBottom: '10px' }}>
      {('*'+t('pdetail.uni2'))}
    </div>
)}

{itensFiltrados.some(item => String(item.qtcx).includes('10/100*')) && (
    <div style={{ color: 'var(--logo-bege)', fontWeight: 'bold', marginBottom: '10px' }}>
      {('*'+t('pdetail.uni10'))}
    </div>
)}

{itensFiltrados.some(item => String(item.qtcx).includes('20/100*')) && (
    <div style={{ color: 'var(--logo-bege)', fontWeight: 'bold', marginBottom: '10px' }}>
      {('*'+t('pdetail.uni20'))}
    </div>
)}

  {itensFiltrados.some(item => String(item.pvp).includes('*')) && (
      <div style={{ color: 'var(--logo-bege)', fontWeight: 'bold', marginBottom: '10px' }}>* {t('pdetail.stockmsg')}</div>
  )}
  </div>

  {acessorios && acessorios.length? (
  <div className="container recomented-prods acessorios">
    <div className="row mb-5">
    <h5 className='prod-info-title'>{t('pdetail.acesso')}</h5> 
          <div className="slider-acessories">
          {acessorios.map((resu, index) =>  {
            return (
              <div className="" key={index}>
                <ProductCard resu={resu} toggleFavorite={toggleFavorite} addToRecentView={addToRecentView} t={t} />
              </div> 
            )
          }
          )}
          </div>
    </div>
</div>
):""}

 {recomendMarcCate && recomendMarcCate.length? (
  <div className="container recomented-prods">
    <div className="row mb-5">
          {/*Produtos pela mesma categoria */}
        <div className="slider-container">
        <h5 className='prod-info-title'>{t('pdetail.tbmGostar')}</h5>
        <Slider {...recomen2}>
        {recomendMarcCate.filter((resu) => (resu.marca === product.marca) && (resu.idP !== product.idP)).sort((a, b) => a.nome.localeCompare(b.nome)).slice(0, 25).map((resu,index)=>(
          <div className="col-sm-6 col-md-3" key={index}>
          <ProductCard resu={resu} toggleFavorite={toggleFavorite} addToRecentView={addToRecentView} t={t} />
        </div>
          ))}
        </Slider>
        </div>
    </div>
  </div>
  ):""}

<div className="container recently-viewed-products">
  <RecentProds/>
</div>
        
<div className="container legend">
  <div className="prod-info-title">{t('pdetail.legenda')}</div>

  <Dropdown
  title={t('pdetail.tabela')}
  items={tabela.map((item) => ({
    sigla: item.sigla,
    nome: item.nome[i18n.language],
  }))} />

  <Dropdown
  title={t('produtos.ip')}
  items={ip.map((item) => ({
    sigla: item.sigla,
    nome: item.nome[i18n.language],
  }))} />

</div>
    </>
  </div>

  )
}

export default ProdDetail
